import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import {currentCountry} from '@common/constants';

const defaultLng =
  currentCountry === 'TH' ? 'th' : currentCountry === 'ID' ? 'id' : 'en';

i18n
  .use(HttpApi) // Load translations using http (default public/assets/locals/en/translation.json)
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next)
  .init({
    fallbackLng: [defaultLng, 'en'],
    lng: localStorage.getItem('i18nextLng') || defaultLng,
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // order and from where user language should be detected
      order: ['localStorage', 'cookie', 'htmlTag'],

      // keys or params to lookup language from
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18next',

      // cache user language on
      caches: ['localStorage', 'cookie'],
    },
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
  });

export default i18n;
